module.exports = __webpack_public_path__ + "img/97ne.dd31b806.svg";